<h1 mat-dialog-title>{{'TOBA LIGHT.label.Category' | translate}}</h1>
<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex="100">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'TOBA LIGHT.video.title' | translate}}</mat-label>
                    <input matInput formControlName="title" required>
                    <mat-error *ngIf="form.controls.title.errors?.required">{{'TOBA LIGHT.slider.title' | translate}} is required</mat-error>
                </mat-form-field>
            </div>
            <div fxFlex="100">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'TOBA LIGHT.video.descriptions' | translate}}</mat-label>
                    <input matInput formControlName="descriptions">

                </mat-form-field>
            </div>

            <div fxFlex="100">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'TOBA LIGHT.video.videoSrc' | translate}}</mat-label>
                    <input matInput formControlName="videoSrc">

                </mat-form-field>
                {{form.controls.videoSrc.value}}
                <iframe width="100%"  [src]="form.controls.videoSrc.value | safe"></iframe>
<!--                </div>-->
            </div>

<!--            <div fxFlex="40" class="px-2">-->
<!--                <div class="row">-->
<!--                    <div><video autoplay controls width="230" height="100" [src]="data?.video?.videoSrc"></video></div>-->
<!--                </div>-->
<!--                <p class="mt-1"><span class="uppercase fw-500">{{'TOBA LIGHT.slider.video' | translate}}</span><span class="text-muted px-1">{{'TOBA LIGHT.slider.maxImages' | translate}}</span></p>-->
<!--                <input type="file" accept="video/*" (change)="fileUpload($event)" />-->
<!--&lt;!&ndash;                <input-file formControlName="videoSrc" (change)="fileUpload($event)" fileLimit="1" fileAccept="video/*"></input-file>&ndash;&gt;-->
<!--            </div>-->
        </div>
    </div>
    <div mat-dialog-actions>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100">
            <button mat-raised-button color="warn" type="button" mat-dialog-close>{{'TOBA LIGHT.label.close' | translate}}</button>
            <button mat-raised-button color="primary" type="submit">{{'TOBA LIGHT.label.save' | translate}}</button>
        </div>
    </div>
</form>
